import {useState, useMemo} from 'react'
import {createPortal} from 'react-dom'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'
import * as Yup from 'yup'
import {Col, Modal, Row} from 'react-bootstrap'
import EmailReport from './EmailReport'
import {useFormik} from 'formik'
import {useLazyQuery, useMutation} from '@apollo/client'
import {CREATE_REPORT_SETTINGS, SEND_ALERTS_TO_EMAIL} from '../../../../../utils/GraphQLAPI'
import {getToken, alert} from '../../../../../utils/helper'
import ScheduleRecurring from './ScheduleRecurring'
import fileDownload from 'js-file-download'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import TextField from '../../../../sharedComponent/TextField/TextField'

type Props = {
  show: boolean
  handleClose: () => void
  filterOptions: any
  dateFilterType: string
}

const modalsRoot = document.getElementById('root-modals') || document.body

const enrollSchema = Yup.object().shape({
  emailId: Yup.string().required('Email is required'),
  subject: Yup.string().required('Subject is required'),
  reportName: Yup.string().required('Subject is required'),
  daysForPhone: Yup.number()
    .typeError('No. of days must be a number')
    .positive('No. of days must be a positive number'),
  daysForEmail: Yup.number()
    .typeError('No. of days must be a number')
    .positive('No. of days must be a positive number'),
  DBtwAgentAndService: Yup.number()
    .typeError('Distance must be a number')
    .positive('Distance must be a positive number'),
  DBtwAgentAndCustomer: Yup.number()
    .typeError('Distance must be a number')
    .positive('Distance must be a positive number'),
  Enrollment: Yup.number()
    .typeError('No. of Minutes must be a number')
    .positive('No. of Minutes must be a positive number'),
  ExceededEnrollment: Yup.number()
    .typeError('No. of Enrollments must be a number')
    .positive('No. of Enrollments must be a positive number'),
})
const generateReportFileName = (reportType: string) => {
  const today = new Date()
  const dateString = moment(today).format('MM-DD-YYYY')
  return `Alerts Reports _ ${reportType.replace(' ', '')} _ ${dateString}`
}

const defaultConfig = {
  selectedTime: '12:00 AM',
  currentScreen: 'QUICKDOWNLOAD',
  scheduleType: 'DAILY',
  selectedDay: 'MONDAY',
  selectedDate: '1',
  fileFormat: 'EXCEL',
  isCheckAll: false,
}

const AlertReportModaal = ({show, handleClose, dateFilterType}: Props) => {
  const [isCheckAll, setIsCheckAll] = useState<any>(false)
  const [fileFormat, setFileFormat] = useState<any>(defaultConfig.fileFormat)

  const [currentScreen, setCurrentScreen] = useState(defaultConfig.currentScreen)
  const [scheduleType, setScheduleType] = useState(defaultConfig.scheduleType)
  const [selectedDay, setSelectedDay] = useState(defaultConfig.selectedDay)
  const [selectedDate, setSelectedDate] = useState('1')
  const [selectedTime, setSelectedTime] = useState<any>(defaultConfig.selectedTime)

  const [sendEmailReport] = useLazyQuery(SEND_ALERTS_TO_EMAIL, {
    onCompleted: (data) => {
      alert('Alerts Report sent successfully', 'success')
    },
    onError: (data) => {
      alert(data.message, 'error')
    },
  })
  const handleBackScreen = () => {
    setCurrentScreen('QUICKDOWNLOAD')
  }
  const handleModalClose = () => {
    handleClose()
  }
  const integerFields = [
    'DBtwAgentAndService',
    'DBtwAgentAndCustomer',
    'daysForPhone',
    'daysForEmail',
    'Enrollment',
    'ExceededEnrollment',
  ]
  const formik = useFormik({
    initialValues: {
      emailId: '',
      subject: '',
      reportName: '',
      DBtwAgentAndService: '',
      DBtwAgentAndCustomer: '',
      daysForPhone: '',
      daysForEmail: '',
      Enrollment: '',
      ExceededEnrollment: '',
    },
    validationSchema: enrollSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      const emailIds = values.emailId.split(',')
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const regexResult = emailIds.map((emailId: string) => regex.test(emailId.trim()))
      if (regexResult.some((result) => result === false)) {
        //setIsEmailValid(false)
        alert('Invalid Email Ids', 'error')
      } else {
        sendEmailReport({
          variables: {
            emailIds,
            subject: values.subject,
            input: {
              reportTimeZone: momentTimezone.tz.guess(),
              minDistanceBtwAgentAndCustomer: values.DBtwAgentAndCustomer
                ? parseFloat(values.DBtwAgentAndCustomer)
                : null,
              minDistanceBtwAgentAndServiceAddress: values.DBtwAgentAndService
                ? parseFloat(values.DBtwAgentAndService)
                : null,
              noOfDaysPhoneRepeated: values.daysForPhone ? parseInt(values.daysForPhone, 10) : null,
              noOfDaysMailRepeated: values.daysForEmail ? parseInt(values.daysForEmail, 10) : null,
              enrollmentsByAgentInMinutes: values.Enrollment
                ? parseInt(values.Enrollment, 10)
                : null,
              maximumEnrollmentOfAgentInADay: values.ExceededEnrollment
                ? parseInt(values.ExceededEnrollment, 10)
                : null,
            },
          },
        })
        handleModalClose()
      }
    },
  })

  useMemo(() => {
    if (show) {
      setCurrentScreen(defaultConfig.currentScreen)
      setSelectedDay(defaultConfig.selectedDay)
      setFileFormat(defaultConfig.fileFormat)

      isCheckAll && setIsCheckAll(false)
      formik.setValues({
        emailId: '',
        subject: '',
        reportName: '',
        DBtwAgentAndService: '',
        DBtwAgentAndCustomer: '',
        daysForPhone: '',
        daysForEmail: '',
        Enrollment: '',
        ExceededEnrollment: '',
      })
      formik.setTouched({})
      setSelectedTime(defaultConfig.selectedTime)
    }
  }, [show])

  const [scheduleReport] = useMutation(CREATE_REPORT_SETTINGS, {
    onCompleted: () => {
      alert('Scheduled alerts report successfully', 'success')
      handleModalClose()
    },
    onError: (err) => {
      alert(err.message, 'error')
    },
  })

  const handleScheduleApi = () => {
    scheduleReport({
      variables: {
        createReportSettingsInput: {
          reportFilters: {
            reportTimeZone: momentTimezone.tz.guess(),
            minDistanceBtwAgentAndCustomer: formik.values.DBtwAgentAndCustomer
              ? parseFloat(formik.values.DBtwAgentAndCustomer)
              : null,
            minDistanceBtwAgentAndServiceAddress: formik.values.DBtwAgentAndService
              ? parseFloat(formik.values.DBtwAgentAndService)
              : null,
            noOfDaysPhoneRepeated: formik.values.daysForPhone
              ? parseInt(formik.values.daysForPhone, 10)
              : null,
            noOfDaysMailRepeated: formik.values.daysForEmail
              ? parseInt(formik.values.daysForEmail, 10)
              : null,
            enrollmentsByAgentInMinutes: formik.values.Enrollment
              ? parseInt(formik.values.Enrollment, 10)
              : null,
            maximumEnrollmentOfAgentInADay: formik.values.ExceededEnrollment
              ? parseInt(formik.values.ExceededEnrollment, 10)
              : null,
          },
          reportName: formik.values.reportName,
          reportFor: 'ALERT',
          reportFormat: 'EXCEL',
          reportTimeZone: 'ET',
          reportTime: selectedTime,
          reportType: dateFilterType?.toUpperCase()?.replaceAll(' ', '_'),
          reportFrequency: scheduleType,
        },
      },
    })
  }

  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }
  const handleRestAPIDownload = async (downloadURL: string, mode: string) => {
    const TOKEN = await getToken()
    const res = await fetch(downloadURL, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        reportTimeZone: momentTimezone.tz.guess(),
        minDistanceBtwAgentAndCustomer: formik.values.DBtwAgentAndCustomer
          ? parseFloat(formik.values.DBtwAgentAndCustomer)
          : null,
        minDistanceBtwAgentAndServiceAddress: formik.values.DBtwAgentAndService
          ? parseFloat(formik.values.DBtwAgentAndService)
          : null,
        noOfDaysPhoneRepeated: formik.values.daysForPhone
          ? parseInt(formik.values.daysForPhone, 10)
          : null,
        noOfDaysMailRepeated: formik.values.daysForEmail
          ? parseInt(formik.values.daysForEmail, 10)
          : null,
        enrollmentsByAgentInMinutes: formik.values.Enrollment
          ? parseInt(formik.values.Enrollment, 10)
          : null,
        maximumEnrollmentOfAgentInADay: formik.values.ExceededEnrollment
          ? parseInt(formik.values.ExceededEnrollment, 10)
          : null,
      }),
    })
    handleModalClose()
    const blob = await res.blob()
    const newBlob = new Blob([blob])
    if (mode === 'QUICK_DOWNLOAD') {
      fileDownload(
        newBlob,
        `${generateReportFileName(dateFilterType)}${fileFormat === 'EXCEL' ? '.xlsx' : '.csv'}`
      )
    }
  }
  const isButtonDisabled = () => {
    const allFields = integerFields.map((field) => formik.getFieldMeta(field).value)
    const noValuesEntered = allFields.every((value) => !value) // Check if all fields are empty or falsy
    const hasNegativeValue = allFields.some((value) => parseInt(value, 10) < 0) // Check if any field has a negative value

    return noValuesEntered || hasNegativeValue // Disable button if no values or any negative value
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-650px'
      show={show}
      onHide={handleModalClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title'>Alerts</h4>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => handleModalClose()}
        >
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2'>
        <div className='modal-md'>
          <div className='modal-content'>
            <div className='modal-body pt-0'>
              {currentScreen === 'EMAILREPORT' && <EmailReport formik={formik} />}
              {currentScreen === 'QUICKDOWNLOAD' && (
                <>
                  <form onSubmit={formik.handleSubmit}>
                    <Row className='d-flex align-items-end mt-5 no-gutters noPadding'>
                      <Col sm={12} md={12} className='pb-7'>
                        <TextField
                          fieldTitle={'Distance between Agent and Service Address'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'DBtwAgentAndService'}
                          placeHolder={'Enter distance in feet'}
                          fieldValue={formik.getFieldMeta('DBtwAgentAndService').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                          className='noPadding'
                        />
                      </Col>
                      <Col sm={12} md={12} className='pb-7'>
                        <TextField
                          fieldTitle={'Distance between Agent and Customer'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'DBtwAgentAndCustomer'}
                          placeHolder={'Enter distance in feet'}
                          fieldValue={formik.getFieldMeta('DBtwAgentAndCustomer').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                        />
                      </Col>
                      <Col sm={12} md={12} className='pb-7'>
                        <TextField
                          fieldTitle={'Phone numbers used in Enrollment more than once in'}
                          fieldTitleAfter={'of days'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'daysForPhone'}
                          placeHolder={'Enter no. of days'}
                          fieldValue={formik.getFieldMeta('daysForPhone').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                        />
                      </Col>
                      <Col sm={12} md={12} className='pb-7'>
                        <TextField
                          fieldTitle={'Emails used in Enrollment more than once in '}
                          fieldTitleAfter={'of days'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'daysForEmail'}
                          placeHolder={'Enter no. of days'}
                          fieldValue={formik.getFieldMeta('daysForEmail').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                        />
                      </Col>

                      <Col sm={12} md={12} className='pb-7'>
                        <TextField
                          fieldTitle={`No. of Enrollments within`}
                          fieldTitleAfter={'minutes by Agent on any day'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'Enrollment'}
                          placeHolder={'Enter no. of minutes'}
                          fieldValue={formik.getFieldMeta('Enrollment').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                        />
                      </Col>
                      <Col sm={12} md={12}>
                        <TextField
                          fieldTitle={'No. of Enrollments exceeds'}
                          fieldTitleAfter={'by Agent on any day'}
                          fieldType={'number'}
                          filedTitleMandatory={false}
                          fieldName={'ExceededEnrollment'}
                          placeHolder={'Enter no. of enrollments'}
                          fieldValue={formik.getFieldMeta('Enrollment').value}
                          handleOnChange={handleOnChange}
                          formik={formik}
                        />
                      </Col>
                    </Row>
                  </form>
                </>
              )}
              {currentScreen === 'SCHEDULERECURRING' && (
                <ScheduleRecurring
                  scheduleType={scheduleType}
                  setScheduleType={setScheduleType}
                  selectedDay={selectedDay}
                  setSelectedDay={setSelectedDay}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  selectedTime={selectedTime}
                  setSelectedTime={setSelectedTime}
                  formik={formik}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='modal-footer'>
        {currentScreen === 'QUICKDOWNLOAD' ? (
          <>
            <button
              type='button'
              className='btn btn-light'
              onClick={() => setCurrentScreen('EMAILREPORT')}
              disabled={isButtonDisabled()}
            >
              Email report
            </button>
            <button
              type='button'
              className='btn btn-light'
              onClick={() => setCurrentScreen('SCHEDULERECURRING')}
              disabled={isButtonDisabled()}
            >
              Schedule download
            </button>
            <button
              className='btn btn-primary'
              data-bs-dismiss='modal'
              onClick={() =>
                handleRestAPIDownload(
                  `${process.env.REACT_APP_BASE_URL}downloads/alertReports`,
                  'QUICK_DOWNLOAD'
                )
              }
              disabled={isButtonDisabled()}
            >
              Quick download
            </button>
          </>
        ) : (
          <>
            <button type='button' className='btn btn-light' onClick={() => handleBackScreen()}>
              Back
            </button>
            <button
              className='btn btn-primary'
              onClick={() => {
                currentScreen === 'EMAILREPORT'
                  ? formik.errors && formik.submitForm()
                  : handleScheduleApi()
              }}
              data-bs-dismiss='modal'
            >
              {currentScreen === 'EMAILREPORT' ? 'Send' : 'Save'}
            </button>
          </>
        )}
      </div>
    </Modal>,
    modalsRoot
  )
}

export {AlertReportModaal}
